module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    attrs: {
      "id": "STEP-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInfo),
      expression: "showInfo"
    }],
    staticClass: "info"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._v("当前画面时间： "), _c('span', [_vm._v(_vm._s(_vm.step_data[0] == null ? 0 : parseFloat(_vm.step_data[0]).toFixed(1)))]), _vm._v(" 秒")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("注：根据所有元素最长时间播放")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInfo),
      expression: "showInfo"
    }],
    staticClass: "line"
  }), _vm._v(" "), (_vm.step_res_data) ? _c('div', {
    staticClass: "tree",
    attrs: {
      "onselectstart": "return false"
    }
  }, [_c('div', {
    staticClass: "list",
    class: _vm.hideLeft
  }, [(_vm.step_data.length >= 1) ? _c('dl', {
    staticClass: "item",
    on: {
      "mouseover": function($event) {
        return _vm.itemMouseOver(_vm.step_type[0], 'unselect')
      },
      "mouseout": function($event) {
        return _vm.itemMouseOut()
      }
    }
  }, [_c('dt', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.handleSelectList('unselect', _vm.step_type[0], '')
      }
    }
  }, [_c('div', {
    staticClass: "background",
    class: {
      'active': _vm.mouse_over_unselect_item == _vm.step_type[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [(_vm.step_data[1].match('#')) ? _c('span', {
    staticClass: "bgc",
    style: ({
      background: _vm.step_data[1]
    })
  }) : _vm._e(), _vm._v(" "), (_vm.step_res_data[_vm.step_data[1]] != null) ? _c('img', {
    attrs: {
      "src": _vm.step_res_data[_vm.step_data[1]].thumb
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.step_res_data[_vm.step_data[1]] != null) ? _c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.scene_title
    }
  }, [_vm._v(_vm._s(_vm.scene_title))]) : _vm._e(), _vm._v(" "), (_vm.step_data[1].match('#')) ? _c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.step_data[1]
    }
  }, [_vm._v(_vm._s(_vm.step_data[1]))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item == _vm.step_type[0]),
      expression: "mouse_over_unselect_item == step_type[0]"
    }],
    staticClass: "icon-top_nav_delete_1",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelScene($event)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.step_data[2]), function(item, index) {
    return (_vm.step_data[2]) ? _c('dl', {
      staticClass: "item"
    }, [_c('dt', {
      staticClass: "no",
      on: {
        "click": function($event) {
          return _vm.handleSelectList(item[0], _vm.step_type[1], '')
        },
        "mouseover": function($event) {
          return _vm.itemMouseOver(item, _vm.step_type[1])
        },
        "mouseout": function($event) {
          return _vm.itemMouseOut()
        }
      }
    }, [_c('div', {
      staticClass: "background",
      class: {
        'active': item == _vm.mouse_over_select_item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner"
    }, [(item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item[item.length - 1]),
        expression: "item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-up",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[1], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item[item.length - 1]),
        expression: "!item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-down",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[1], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [(_vm.step_res_data[item[1]] != null) ? _c('img', {
      attrs: {
        "src": _vm.getRoleData(item).thumb
      }
    }) : _vm._e(), _vm._v(" "), (item[0][0] == 'C') ? _c('img', {
      attrs: {
        "src": require("./top_combination.png")
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.getRoleData(item) != null) ? _c('div', {
      staticClass: "title",
      attrs: {
        "title": _vm.getRoleData(item).title
      }
    }, [_vm._v(_vm._s(_vm.getRoleData(item).text))]) : _vm._e(), _vm._v(" "), (item[3].length == 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item "
      }],
      staticClass: "group-no-action"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus",
      attrs: {
        "src": "el-icon-plus"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }],
      staticClass: "no-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[1], index, 'enter')
        },
        "blur": function($event) {
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[1], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), (item[0][0] != 'C') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo && item[0][0] != 'C'),
        expression: "showInfo && item[0][0] != 'C'"
      }],
      staticClass: "add_step",
      attrs: {
        "title": "添加动作"
      },
      on: {
        "click": function($event) {
          return _vm.addStep(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }],
      staticClass: "group-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[1], index, 'enter')
        },
        "blur": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[1], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parseFloat(item[4]).toFixed(1) > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item != _vm.mouse_over_select_item),
        expression: "item != mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      staticClass: "delay-time",
      staticStyle: {
        "color": "#e2e2e2"
      }
    }, [_vm._v("+ " + _vm._s(parseFloat(item[4]).toFixed(2)) + "S")])]) : _vm._e()])]), _vm._v(" "), _vm._l((item[3]), function(action) {
      return (item[3].length > 0) ? _c('dd', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item[item.length - 1]),
          expression: "item[item.length-1]"
        }],
        on: {
          "mouseover": function($event) {
            return _vm.itemMouseOver(item, 'action')
          },
          "mouseout": function($event) {
            return _vm.itemMouseOut()
          },
          "click": function($event) {
            return _vm.handleSelectList(item[0], _vm.step_type[1], 'action')
          }
        }
      }, [_c('div', {
        staticClass: "background",
        class: {
          'active': _vm.mouse_over && item == _vm.mouse_over_item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "inner"
      }, [_vm._m(0, true), _vm._v(" "), _c('div', {
        staticClass: "title",
        attrs: {
          "title": _vm.getActionName(action)
        }
      }, [_vm._v(_vm._s(_vm.getActionName(action)))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.mouse_over && item == _vm.mouse_over_item),
          expression: "mouse_over && item == mouse_over_item"
        }],
        staticClass: "group"
      }, [(action.length > 3 && action[3] && item[0][0] != 'C' && action[0].substring(0, 2) != '74') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.action_input_value),
          expression: "action_input_value"
        }, {
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "action_time",
        attrs: {
          "placeholder": _vm.getActionTime(action)
        },
        domProps: {
          "value": (_vm.action_input_value)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeActionTime1($event)
          },
          "change": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, _vm.step_type[1], index)
          },
          "keyup": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.changeActionTime(item[0], _vm.action_input_value, 'enter', _vm.step_type[1], index)
          },
          "blur": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, '', _vm.step_type[1], index)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.action_input_value = $event.target.value
          }
        }
      }) : _vm._e(), (action.length > 3 && action[3]) ? _c('i', {
        staticClass: "no_combine"
      }, [_vm._v("s")]) : _vm._e(), _vm._v(" "), (action.length > 3 && action[3] && item[0][0] == 'C' && action[0].substring(0, 2) != '74') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.action_input_value),
          expression: "action_input_value"
        }, {
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "action_time_C",
        attrs: {
          "placeholder": _vm.getActionTime(action)
        },
        domProps: {
          "value": (_vm.action_input_value)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeActionTime1($event)
          },
          "change": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, _vm.step_type[1], index)
          },
          "keyup": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.changeActionTime(item[0], _vm.action_input_value, 'enter', _vm.step_type[1], index)
          },
          "blur": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, '', _vm.step_type[1], index)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.action_input_value = $event.target.value
          }
        }
      }) : _vm._e(), (action.length > 3 && action[3] && item[0][0] == 'C') ? _c('i', {
        staticClass: "combine"
      }, [_vm._v("s")]) : _vm._e(), _vm._v(" "), (item[0][0] != 'C' && action[0].substring(0, 2) != '74' && _vm.action_enable) ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.tab_type == 3 ? false : true),
          expression: "tab_type == 3 ? false : true"
        }],
        staticClass: "icon-home",
        attrs: {
          "title": "编辑"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.handleEditAction(item[0], item[1], action[0], _vm.getActionName(action))
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "icon-top_nav_delete_1",
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleDelAction(item[0], action[0])
          }
        }
      })]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item != _vm.mouse_over_item),
          expression: "item != mouse_over_item"
        }],
        staticClass: "group"
      }, [_c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0) + "S")])])])]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.step_data[3]), function(item, index) {
    return (_vm.step_data[3]) ? _c('dl', {
      staticClass: "item"
    }, [_c('dt', {
      staticClass: "no",
      attrs: {
        "data-alias": item[0]
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectList(item[0], _vm.step_type[2], '')
        },
        "mouseover": function($event) {
          return _vm.itemMouseOver(item, _vm.step_type[2])
        },
        "mouseout": function($event) {
          return _vm.itemMouseOut()
        }
      }
    }, [_c('div', {
      staticClass: "background",
      class: {
        'active': item == _vm.mouse_over_select_item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner"
    }, [(item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item[item.length - 1]),
        expression: "item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-up",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[2], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item[item.length - 1]),
        expression: "!item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-down",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[2], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [(_vm.step_res_data[item[1]] != null) ? _c('img', {
      attrs: {
        "src": _vm.step_res_data[item[1]].thumb
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.step_res_data[item[1]] != null) ? _c('div', {
      staticClass: "title",
      attrs: {
        "title": _vm.step_res_data[item[1]].title
      }
    }, [_vm._v(_vm._s(_vm.tab_type == 3 ? "" : "") + _vm._s(_vm.step_res_data[item[1]].title))]) : _vm._e(), _vm._v(" "), (item[3].length == 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item"
      }],
      staticClass: "group-no-action"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus",
      attrs: {
        "src": "el-icon-plus"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "no-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[2], index, 'enter')
        },
        "blur": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[2], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "add_step",
      attrs: {
        "title": "添加动作"
      },
      on: {
        "click": function($event) {
          return _vm.addStep(item)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "group-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[2], index, 'enter')
        },
        "blur": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[2], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parseFloat(item[4]).toFixed(1) > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item != _vm.mouse_over_select_item),
        expression: "item != mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      staticClass: "delay-time",
      staticStyle: {
        "color": "#e2e2e2"
      }
    }, [_vm._v("+ " + _vm._s(parseFloat(item[4]).toFixed(2)) + "S")])]) : _vm._e()])]), _vm._v(" "), _vm._l((item[3]), function(action) {
      return (item[3].length > 0) ? _c('dd', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item[item.length - 1]),
          expression: "item[item.length-1]"
        }],
        on: {
          "click": function($event) {
            return _vm.handleSelectList(item[0], _vm.step_type[2], 'action')
          },
          "mouseover": function($event) {
            return _vm.itemMouseOver(item, 'action')
          },
          "mouseout": function($event) {
            return _vm.itemMouseOut()
          }
        }
      }, [_c('div', {
        staticClass: "background",
        class: {
          'active': _vm.mouse_over && item == _vm.mouse_over_item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "inner"
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticClass: "title",
        attrs: {
          "title": _vm.getActionName(action)
        }
      }, [_vm._v(" " + _vm._s(_vm.getActionName(action)))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.mouse_over && item == _vm.mouse_over_item),
          expression: "mouse_over && item == mouse_over_item"
        }],
        staticClass: "group"
      }, [(action.length > 3 && action[3] && item[0][0] != 'C' && action[0].substring(0, 2) != '74') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.action_input_value),
          expression: "action_input_value"
        }, {
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "action_time",
        attrs: {
          "placeholder": _vm.getActionTime(action)
        },
        domProps: {
          "value": (_vm.action_input_value)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeActionTime1($event)
          },
          "keyup": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.changeActionTime(item[0], _vm.action_input_value, 'enter', _vm.step_type[2], index)
          },
          "blur": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, '', _vm.step_type[2], index)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.action_input_value = $event.target.value
          }
        }
      }) : _vm._e(), (action.length > 3 && action[3]) ? _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "no_combine"
      }, [_vm._v("s")]) : _vm._e(), _vm._v(" "), (action[0].substring(0, 2) != '74' && _vm.action_enable) ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "icon-home",
        attrs: {
          "title": "编辑"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.handleEditAction(item[0], item[1], action[0], _vm.getActionName(action))
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "icon-top_nav_delete_1",
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleDelAction(item[0], action[0])
          }
        }
      })]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item != _vm.mouse_over_item),
          expression: "item != mouse_over_item"
        }],
        staticClass: "group"
      }, [_c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0) + "S")])])])]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.step_data[4]), function(item, index) {
    return _c('dl', {
      staticClass: "item"
    }, [_c('dt', {
      staticClass: "no",
      attrs: {
        "data-alias": item[0]
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectList(item[0], _vm.step_type[3], '')
        },
        "mouseover": function($event) {
          return _vm.itemMouseOver(item, _vm.step_type[3])
        },
        "mouseout": function($event) {
          return _vm.itemMouseOut()
        }
      }
    }, [_c('div', {
      staticClass: "background",
      class: {
        'active': item == _vm.mouse_over_select_item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner"
    }, [(item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item[item.length - 1]),
        expression: "item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-up",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[3], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item[item.length - 1]),
        expression: "!item[item.length-1]"
      }],
      staticClass: "el-icon-arrow-down",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.itemArrowClick(item, _vm.step_type[3], index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [(_vm.step_res_data[item[1]] != null) ? _c('img', {
      attrs: {
        "src": _vm.step_res_data[item[1]].thumb
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.step_res_data[item[1]] != null) ? _c('div', {
      staticClass: "title",
      attrs: {
        "title": _vm.step_res_data[item[1]].title
      }
    }, [_vm._v(_vm._s(_vm.step_res_data[item[1]].title))]) : _vm._e(), _vm._v(" "), (item[3].length == 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item"
      }],
      staticClass: "group-no-action"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus",
      attrs: {
        "src": "el-icon-plus"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "no-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[3], index, 'enter')
        },
        "blur": function($event) {
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[3], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "add_step",
      attrs: {
        "title": "添加动作"
      },
      on: {
        "click": function($event) {
          return _vm.addStep(item)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item[3].length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item == _vm.mouse_over_select_item),
        expression: "item == mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delay_input_value),
        expression: "delay_input_value"
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }],
      staticClass: "group-action-input",
      attrs: {
        "placeholder": _vm.getDelayTime(item)
      },
      domProps: {
        "value": (_vm.delay_input_value)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addDelayTime1($event)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[3], index, 'enter')
        },
        "blur": function($event) {
          return _vm.addDelayTime(item, _vm.delay_input_value, _vm.step_type[3], index, '')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delay_input_value = $event.target.value
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showInfo),
        expression: "showInfo"
      }]
    }, [_vm._v("s")]), _vm._v(" "), _c('div', {
      staticClass: "icon-top_nav_delete_1",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelMaterial(item[0])
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parseFloat(item[4]).toFixed(1) > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item != _vm.mouse_over_select_item),
        expression: "item != mouse_over_select_item"
      }],
      staticClass: "group-action"
    }, [_c('div', {
      staticClass: "delay-time",
      staticStyle: {
        "color": "#e2e2e2"
      }
    }, [_vm._v("+ " + _vm._s(parseFloat(item[4]).toFixed(2)) + "S")])]) : _vm._e()])]), _vm._v(" "), _vm._l((item[3]), function(action) {
      return (item[3].length > 0) ? _c('dd', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item[item.length - 1]),
          expression: "item[item.length-1]"
        }],
        on: {
          "click": function($event) {
            return _vm.handleSelectList(item[0], _vm.step_type[3], 'action')
          },
          "mouseover": function($event) {
            return _vm.itemMouseOver(item, 'action')
          },
          "mouseout": function($event) {
            return _vm.itemMouseOut()
          }
        }
      }, [_c('div', {
        staticClass: "background",
        class: {
          'active': _vm.mouse_over && item == _vm.mouse_over_item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "inner"
      }, [_vm._m(2, true), _vm._v(" "), _c('div', {
        staticClass: "title",
        attrs: {
          "title": _vm.getActionName(action)
        }
      }, [_vm._v(_vm._s(_vm.getActionName(action)))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.mouse_over && item == _vm.mouse_over_item),
          expression: "mouse_over && item == mouse_over_item"
        }],
        staticClass: "group"
      }, [(action.length > 3 && action[3] && item[0][0] != 'C' && action[0].substring(0, 2) != '74') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.action_input_value),
          expression: "action_input_value"
        }, {
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "action_time",
        attrs: {
          "placeholder": _vm.getActionTime(action)
        },
        domProps: {
          "value": (_vm.action_input_value)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeActionTime1($event)
          },
          "keyup": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.changeActionTime(item[0], _vm.action_input_value, 'enter', _vm.step_type[3], index)
          },
          "blur": function($event) {
            return _vm.changeActionTime(item[0], _vm.action_input_value, '', _vm.step_type[3], index)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.action_input_value = $event.target.value
          }
        }
      }) : _vm._e(), (action.length > 3 && action[3]) ? _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "no_combine"
      }, [_vm._v("s")]) : _vm._e(), _vm._v(" "), (action[0].substring(0, 2) != '74' && _vm.action_enable) ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showInfo),
          expression: "showInfo"
        }],
        staticClass: "icon-home",
        attrs: {
          "title": "编辑"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.handleEditAction(item[0], item[1], action[0], _vm.getActionName(action))
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "icon-top_nav_delete_1",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleDelAction(item[0], action[0])
          }
        }
      })]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item != _vm.mouse_over_item),
          expression: "item != mouse_over_item"
        }],
        staticClass: "group"
      }, [_c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0) + "S")])])])]) : _vm._e()
    })], 2)
  }), _vm._v(" "), (_vm.step_data[5]) ? _c('dl', {
    staticClass: "item",
    on: {
      "mouseover": function($event) {
        return _vm.itemMouseOver(_vm.step_type[4], 'unselect')
      },
      "mouseout": function($event) {
        return _vm.itemMouseOut()
      }
    }
  }, [_c('dt', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.handleSelectList('unselect', _vm.step_type[4], '')
      }
    }
  }, [_c('div', {
    staticClass: "background",
    class: {
      'active': _vm.mouse_over_unselect_item == _vm.step_type[4]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.step_data[5]))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item == _vm.step_type[4]),
      expression: "mouse_over_unselect_item == step_type[4]"
    }],
    staticClass: "icon-top_nav_delete_1",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelSubtitle($event)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step_data[6] != 0 && _vm.step_data[6] != undefined) ? _c('dl', {
    staticClass: "item",
    on: {
      "mouseover": function($event) {
        return _vm.itemMouseOver(_vm.step_type[5], 'unselect')
      },
      "mouseout": function($event) {
        return _vm.itemMouseOut()
      }
    }
  }, [_c('dt', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.handleSelectList('unselect', _vm.step_type[5], '')
      }
    }
  }, [_c('div', {
    staticClass: "background",
    class: {
      'active': _vm.mouse_over_unselect_item == _vm.step_type[5]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._m(4), _vm._v(" "), (_vm.step_data[6] >= 0) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("镜头")]) : _vm._e(), _vm._v(" "), (_vm.step_data[6] == -1) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("镜头跟随")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [(_vm.step_data[6] >= 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item != _vm.step_type[5]),
      expression: "mouse_over_unselect_item != step_type[5]"
    }],
    staticClass: "time",
    staticStyle: {
      "margin-right": "-15px"
    }
  }, [_vm._v(_vm._s(parseFloat(_vm.step_data[6]).toFixed(2)) + "S")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item == _vm.step_type[5]),
      expression: "mouse_over_unselect_item == step_type[5]"
    }],
    staticClass: "icon-top_nav_delete_1",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelCamera($event)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.step_data[7] && _vm.step_data[7][0] != undefined) ? _c('dl', {
    staticClass: "item",
    on: {
      "mouseover": function($event) {
        return _vm.itemMouseOver(_vm.step_type[6], 'unselect')
      },
      "mouseout": function($event) {
        return _vm.itemMouseOut()
      }
    }
  }, [_c('dt', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.handleSelectList('unselect', _vm.step_type[6], '')
      }
    }
  }, [_c('div', {
    staticClass: "background",
    class: {
      'active': _vm.mouse_over_unselect_item == _vm.step_type[6]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("配音")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(parseFloat(_vm.step_data[7][1]).toFixed(2)) + "S")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item == _vm.step_type[6]),
      expression: "mouse_over_unselect_item == step_type[6]"
    }],
    staticClass: "icon-top_nav_delete_1",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelDub($event)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step_data[8] && _vm.step_data[8].length > 0) ? _c('dl', {
    staticClass: "item",
    on: {
      "mouseover": function($event) {
        return _vm.itemMouseOver(_vm.step_type[7], 'unselect')
      },
      "mouseout": function($event) {
        return _vm.itemMouseOut()
      }
    }
  }, [_c('dt', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.handleSelectList('unselect', _vm.step_type[7], '')
      }
    }
  }, [_c('div', {
    staticClass: "background",
    class: {
      'active': _vm.mouse_over_unselect_item == _vm.step_type[7]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.action_bgm_data.title
    }
  }, [_vm._v(_vm._s(_vm.action_bgm_data.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouse_over_unselect_item == _vm.step_type[7]),
      expression: "mouse_over_unselect_item == step_type[7]"
    }],
    staticClass: "icon-top_nav_delete_1",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelBgm($event)
      }
    }
  })])])]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-nav_text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-nav_scene"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-mic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-nav_voice"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-958cb8c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Step/Step.vue
// module id = 396
// module chunks = 0